import { type UserRole } from '@/utilities/buildUserRoles.js';
import { getArticleForNoun } from '@/utilities/getArticleForNoun.js';

export const buildHeadline = (fullName: string, roles: UserRole[]): string => {
  if (!roles.length) return fullName;

  const rolesNames = roles.map(({ name }) => name);

  const startingArticle = getArticleForNoun(rolesNames[0]);

  if (rolesNames.length === 1) {
    return `${fullName} is ${startingArticle} ${rolesNames[0]}.`;
  }

  const lastItemString = `and ${rolesNames[rolesNames.length - 1]}`;
  const allWithoutLastItemString = rolesNames.slice(0, -1).join(', ');

  const headline = `${fullName} is ${startingArticle} ${allWithoutLastItemString} ${lastItemString}.`;

  return headline;
};
